export default __webpack_public_path__ + "static/media/Uganda.90755aa7.png";